import { render, staticRenderFns } from "./MentorshipGroupChatBubbleText.vue?vue&type=template&id=6fa4c087&"
import script from "./MentorshipGroupChatBubbleText.vue?vue&type=script&lang=js&"
export * from "./MentorshipGroupChatBubbleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports